var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-panel__dashboard"},[_c('AdminPanelDashboardMenu',{attrs:{"data":_vm.menuItems}}),_c('div',{staticClass:"admin-panel__dashboard__сontent"},[_c('div',{staticClass:"admin-panel__dashboard__title"},[_c('p',{staticClass:"admin-panel__dashboard__title-text"},[_vm._v(" "+_vm._s(_vm.textTitle)+" ")])]),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }